export default function SearchIcon({ className = "cursor-pointer" }: { className?: string }) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g opacity="0.4">
        <circle cx="10.0835" cy="10.083" r="5.5" stroke="currentColor" strokeWidth="1.5" />
        <path d="M18.3335 18.333L15.5835 15.583" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
      </g>
    </svg>
  );
}
